const getTheme = (): string => {
  return "ppe";
};

export default getTheme;
